import { useEffect, useLayoutEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useAlert } from "../context/AlertContext";
import { useLoading } from "../context/LoadingContext";
import {
  interceptorRequest,
  interceptorResponseSuccess,
  interceptorResponseError
} from "../utils/Interceptor";
import axios from "axios";
import AppLayout from "./AppLayout";
import AuthService from "../services/auth.service";
import ChooseCompany from "../pages/Login/choose_company";

const PrivateRoutes = () => {
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { user, setUser } = useAuth();

  const refreshToken = () => {
    setLoading(true);
    AuthService.refresh(user.refreshToken)
      .then((response) =>
        setUser({
          ...user,
          accessToken: response.accessToken,
          refreshToken: response.refreshToken
        })
      )
      .catch(({ error, message }) => {
        showAlert({ error, message, type: "danger" });
        handleLogout(user.refreshToken);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleLogout = () => {
    setLoading(true);
    AuthService.logout(user.refreshToken)
      .then((_) => {
        showAlert({ error: "เข้าสู่ระบบเรียบร้อย", type: "success" });
        setUser(null);
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => {
        setLoading(false);
      });
  };

  const checkTokenExpiration = () => {
    if (user?.accessToken) {
      const tokenExpiredThreshold = 5 * 60 * 1000;
      const currentTime = Date.now();
      const tokenExpiredTime =
        JSON.parse(atob(user.accessToken.split(".")[1])).exp * 1000;

      if (tokenExpiredTime - currentTime < tokenExpiredThreshold) {
        refreshToken();
      }
    }
  };

  useEffect(() => {
    checkTokenExpiration();
    const refreshInterval = setInterval(checkTokenExpiration, 60 * 1000);

    return () => clearInterval(refreshInterval);
  }, [user]);

  useLayoutEffect(() => {
    const reqInterceptor = axios.interceptors.request.use((config) =>
      interceptorRequest(config, user)
    );
    const resInterceptor = axios.interceptors.response.use(
      (response) => interceptorResponseSuccess(response),
      (error) => interceptorResponseError(error, user, () => setUser(null))
    );
    return () => {
      axios.interceptors.request.eject(reqInterceptor);
      axios.interceptors.response.eject(resInterceptor);
    };
  }, [user]);

  if (user) {
    if (!user.Com_Code)
      return (
        <>
          <Navigate to="/choose_company" replace={true} />
          <ChooseCompany />
        </>
      );

    return (
      <AppLayout>
        <Outlet />
      </AppLayout>
    );
  }

  return <Navigate to="/login" replace={true} />;
};

export default PrivateRoutes;
